import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconHorizontalMoreOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.286 10a1.714 1.714 0 1 0-.001 3.428 1.714 1.714 0 0 0 0-3.428M1.714 10a1.714 1.714 0 1 0 0 3.429 1.714 1.714 0 0 0 0-3.429M12 10a1.714 1.714 0 1 0 0 3.428A1.714 1.714 0 0 0 12 10" /></svg>
);
